/* CRAFTD collection grid behaviour (Danny, 21 Aug 2026).
   Pairs with snippets/product-card-v2.liquid, main-collection's sidebar
   and the homepage cro-home-rail carousels. Event delegation throughout.
   1. '+' quick-add: /cart/add.js then cart:refresh + toggle-cart-drawer.
   2. Gallery dots: track the scroll-snap position of each card's gallery.
   3. Sidebar sort links: rewrite the URL so active filters survive.
   4. PDP sticky ATC bar guard: toggles gs-near-top on <html> from a
      passive scroll listener; CSS does the hiding. No MutationObserver.
   5. Home rail arrows: scroll the rail by ~80% of its width. */
(function () {
  if (window.__gsCardJS) return;
  window.__gsCardJS = true;

  function fire(el, name) {
    el.dispatchEvent(new CustomEvent(name, { bubbles: true, composed: true }));
  }

  function addToCart(el, variantId) {
    if (!variantId) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    el.classList.add('is-busy');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        fire(el, 'cart:refresh');
        fire(el, 'toggle-cart-drawer');
      })
      .finally(function () {
        el.classList.remove('is-busy');
      });
  }

  document.addEventListener('click', function (e) {
    var arrow = e.target.closest('.gsx-rail__arrow');
    if (arrow) {
      var section = arrow.closest('.gsx-rail-section');
      var track = section && section.querySelector('.gsx-rail__track');
      if (track) {
        var dir = parseInt(arrow.getAttribute('data-rail-dir'), 10) || 1;
        track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
      }
      return;
    }

    var toggle = e.target.closest('.gs-qa__toggle');
    if (toggle) {
      e.preventDefault();
      var card = toggle.closest('.gs-card');
      var options = card && card.querySelector('.gs-qa__options');
      if (options) {
        options.classList.toggle('is-open');
      } else {
        addToCart(toggle, toggle.getAttribute('data-variant-id'));
      }
      return;
    }

    var option = e.target.closest('.gs-qa__option');
    if (option) {
      e.preventDefault();
      var id = option.getAttribute('data-variant-id');
      if (id) {
        addToCart(option, id);
        var panel = option.closest('.gs-qa__options');
        if (panel) panel.classList.remove('is-open');
      }
      return;
    }

    // Click anywhere else closes any open size chooser.
    document.querySelectorAll('.gs-qa__options.is-open').forEach(function (p) {
      var host = p.closest('.gs-card');
      if (!host || !host.contains(e.target)) p.classList.remove('is-open');
    });

    var sort = e.target.closest('.gsx-sort__option[data-sort]');
    if (sort) {
      e.preventDefault();
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.getAttribute('data-sort'));
      u.searchParams.delete('page');
      window.location.href = u.toString();
    }
  });

  // Gallery dots via capture-phase scroll (scroll doesn't bubble).
  var raf = null;
  document.addEventListener('scroll', function (e) {
    var g = e.target;
    if (!(g instanceof Element) || !g.classList.contains('gs-card__gallery')) return;
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      var idx = Math.round(g.scrollLeft / Math.max(g.clientWidth, 1));
      var wrap = g.parentElement;
      if (!wrap) return;
      wrap.querySelectorAll('.gs-card__dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    });
  }, true);

  // 4. PDP sticky bar guard - CSS class on <html>, nothing else.
  var nearTopRaf = null;
  function updateNearTop() {
    if (nearTopRaf) return;
    nearTopRaf = requestAnimationFrame(function () {
      nearTopRaf = null;
      document.documentElement.classList.toggle('gs-near-top', window.scrollY < 300);
    });
  }
  window.addEventListener('scroll', updateNearTop, { passive: true });
  updateNearTop();
})();
